export default __webpack_public_path__ + "static/media/cart-04.c082482d.jpg";